import axios from '../http'

function add(data) {
    return axios.post('/basedata/athlete/add', data);
}

function del(data) {
    return axios.post('/basedata/athlete/del', data);
}

function update(data) {
    return axios.post('/basedata/athlete/update', data);
}

function query(data) {
    return axios.post('/basedata/athlete/query', data);
}


function get(id) {
    return axios.get('/basedata/athlete/get?id=' + id);
}
export default {
    add,
    del,
    update,
    query,
    get
}